import React, {Component} from 'react';
import ShowLocalDate from '../LocalDateView'
import PropTypes from 'prop-types';
class CommesseDateCompactView extends Component {

    render() {
        let item = this.props.item;
        if (item === undefined || item === null) return null;
        return <div>
            <div>

                {this.props.showDataIncarico && item.dataIncarico ? <label className="ui tiny green label left floated">Incarico<ShowLocalDate
                    data={item.dataIncarico} showIcon={false}/></label> : null}

                {item.dataInizioPrestazione ? <label className="ui tiny olive label left floated">Inizio Prest<ShowLocalDate
                    data={item.dataInizioPrestazione} showIcon={false}/></label> : null}

                {item.dataFinePrestazione ? <label className="ui tiny orange label left floated">Fine Prest<ShowLocalDate
                    data={item.dataFinePrestazione} showIcon={false}/></label>: null}

                {item.dataChiusura ? <label className="ui tiny red label left floated">Chiusura<ShowLocalDate
                    data={item.dataChiusura} showIcon={false}/></label>: null}

            </div>
        </div>
    }
}

CommesseDateCompactView.PropTypes = {
    item: PropTypes.object,
    showDataIncarico: PropTypes.bool,
};

CommesseDateCompactView.defaultProps = {
    loading: false,
    showDataIncarico: false
};


export default CommesseDateCompactView;


/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseDateCompactView.js
 **/